<script setup lang="ts">
import './assets/style.scss'
import { useModel } from './../model/model'
import { computed, onMounted, type PropType, ref, watch } from 'vue'

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  max: {
    type: Number,
    default: 3,
  },
  rule: {
    type: Array as PropType<Function[]>,
    default: [],
  },
})

const { list, addListItem, removeListItem } = useModel()
const model = defineModel<string[]>()
const currentValue = ref('')
const error = ref('')

/** Обновляем данные модели при изменении списка */
watch(list.value, () => {
  model.value = list.value.map((item) => item.value)
})

/** Вычисляем наличие ошибок валидации */
const valid = computed(() => {
  const value = currentValue.value.trim()

  for (let index in props.rule) {
    const result = props.rule[index](value)
    if (result) return result
  }

  return ''
})

/**
 * Функция обработчик добавления нового элемента
 */
const addItemHandler = () => {
  if (valid.value) {
    error.value = valid.value
  } else {
    addListItem(currentValue.value)
    currentValue.value = ''
  }
}

/**
 * Сбрасываем значение ошибки при вводе
 */
const errorClearHandler = () => {
  error.value = ''
}

/** Добавляем в список имеющиеся в модели элементы */
onMounted(() => {
  model.value?.forEach((item) => {
    addListItem(item)
  })
})
</script>

<template>
  <div class="v-input-chips__wrapper">
    <div class="v-input-chips__list">
      <VChip
        v-for="item in list"
        :key="item.id"
        size="small"
        closable
        @click:close="removeListItem(item.id)"
      >
        {{ item.value }}
      </VChip>
    </div>

    <VTextField
      v-model="currentValue"
      :label
      :disabled="list.length === max"
      :error="!!error"
      hide-details
      @input="errorClearHandler"
      @keydown.enter.prevent="addItemHandler"
    />

    <div class="v-input-chips__hint">
      <div :class="{ 'v-input-chips__error': error }">
        {{ error ? error : $t('itf.submit_enter') }}
      </div>

      <div class="v-input-chips__counter">{{ list.length }} / {{ max }}</div>
    </div>
  </div>
</template>
